import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import { FC } from 'react'

import { Skeleton } from 'shared/components/skeleton'

import mainStyles from '../../FinancialPlanQuality.module.scss'

import styles from './FinancialPlanQualitySkeleton.module.scss'

const PillarSkeleton: FC = () => (
  <P360Card className={styles.pillar}>
    <div className={styles.pillarHeader}>
      <div className={styles.pillarHeaderText}>
        <Skeleton className={styles.title} width={'50%'} height={18} />
        <Skeleton className={styles.description} width={'80%'} height={14} />
      </div>

      <Skeleton width={48} height={20} />
    </div>

    <Skeleton className={styles.progressBar} width={'100%'} height={8} />

    <div className={styles.actions}>
      <Skeleton width={120} height={36} border={'8px'} />
      <Skeleton width={140} height={36} border={'8px'} />
    </div>
  </P360Card>
)

export const FinancialPlanQualitySkeleton: FC = () => {
  return (
    <P360Card className={mainStyles.root}>
      <div className={mainStyles.content}>
        <div className={mainStyles.chart}>
          <Skeleton className={styles.title} width={'60%'} height={18} />
          <Skeleton className={styles.description} width={'90%'} height={14} />

          <div className={mainStyles.donut}>
            <Skeleton width={180} height={180} border={'50%'} />
          </div>
        </div>

        <div className={mainStyles.pillars}>
          <PillarSkeleton />
          <PillarSkeleton />
        </div>
      </div>
    </P360Card>
  )
}
